import React from 'react';
import PropTypes from 'prop-types';
import AliasMacronService from '../../../../services/AliasMacronService';

const Description = ({
  cancelled, routeNameDisplay, platformDisplay, headSignDisplay, enhancedHeadsignDisplay,
}) => {
  const renderHeadsign = () => {
    if (enhancedHeadsignDisplay) {
      return (
        <span className="movement-info-description-enhanced-container">
          <span className="movement-info-description-enhanced-name">{`${AliasMacronService.getMacronisedText(enhancedHeadsignDisplay.name)} `}</span>
          {enhancedHeadsignDisplay.limitedStops && <span className="movement-info-description-enhanced-limited-stops">Limited stops</span>}
          {enhancedHeadsignDisplay.via && <span className="movement-info-description-enhanced-via">{` via ${AliasMacronService.getMacronisedText(enhancedHeadsignDisplay.via)}`}</span>}
        </span>
      );
    }

    return headSignDisplay && (<span className="movement-info-description-destination">{AliasMacronService.getMacronisedText(headSignDisplay)}</span>);
  }

  return (
    <div className="movement-info-description-container" aria-hidden="true">
      <div className="movement-info-description">
        <span className="movement-info-route-short-name">{routeNameDisplay}</span>
        {!cancelled && platformDisplay
          && (
            <span className="movement-info-platform">
              {platformDisplay}
            </span>
          )}
      </div>
      {renderHeadsign()}
    </div>
  );
}
Description.propTypes = {
  cancelled: PropTypes.bool.isRequired,
  routeNameDisplay: PropTypes.string.isRequired,
  platformDisplay: PropTypes.string,
  headSignDisplay: PropTypes.string,
  enhancedHeadsignDisplay: PropTypes.object,
};
Description.defaultProps = {
  headSignDisplay: null,
  platformDisplay: null,
  enhancedHeadsignDisplay: null,
};

export default Description;